<template>
  <div id="promo_container">
    <!--  иконки промо-->
    <PromoIconButton v-show="getAchievementShowingIcon" :type="'achievement'" />
    <PromoIconButton v-show="getTournamentShowingIcon" :type="'tournament'" />
    <promoIconButtonCount v-show="isShowIconCount" :type="'freeBets'" />

    <!--    Прогресс бары-->
    <ProgressBar
      v-if="isShowProgressBar"
      :getCurrentStep="getCurrentStep"
      :getTotalStep="getTotalStep"
      :isProgress="isProgress" />
    <progressBarCheck v-show="isShowProgressCheck" :type="'freeBets'" />

    <!-- Приветствующий попап для ачивок-->
    <WelcomePopup v-show="getAchievementWelcomePopup && !getTournamentShowingWelcomePopup">
      <AchievementsWelcomeContent />
    </WelcomePopup>

    <!-- Приветствующий попап для турниров-->
    <WelcomePopup v-show="getTournamentShowingWelcomePopup && !getAchievementWelcomePopup">
      <TournamentWelcomeContent />
    </WelcomePopup>

    <!-- Приветствующий попап для фрибетов-->
    <TabWelcomeWrapper v-show="isShowFreeBetWelcomePopup" />

    <!--  Попап о всей информации о турнирах-->
    <CommonPopup v-show="getShowingCommonPopup" />

    <!--  Попапы c информацией про фриспины-->
    <WrapperFreeSpins v-show="isFreeSpinWInPopup" v-slot="slotProps">
      <StartFreeSpin :closing="slotProps.closing" />
    </WrapperFreeSpins>

    <WrapperFreeSpins v-show="isFreeSpinFinishPopup" v-slot="slotProps">
      <FinishFreeSpin :closing="slotProps.closing" />
    </WrapperFreeSpins>

    <WrapperFreeSpins v-show="isFreeSpinWInOtherGamePopup" v-slot="slotProps">
      <StartFreeSpinOtherGame :closing="slotProps.closing" />
    </WrapperFreeSpins>

    <WrapperFreeSpins v-show="isPrizeGameWinPopup" v-slot="slotProps">
      <WinPrizeAfterOneSpin :closing="slotProps.closing" />
    </WrapperFreeSpins>

    <!--  меню для иконок-->
    <MoreIcons v-if="isShowMenu" @toggleMenu="toggleMenuIcons" />

    <!--  Всплывающая подсказка-->
    <Tooltip v-if="(hasAchievement && isProgress) || hasFreeBet || hasTournament" />

    <!--    сообщения-->
    <MessageWrapper></MessageWrapper>
  </div>
</template>

<script lang="ts">
import store from '@/store';
import Vue from 'vue';
import { ACTION } from '@/store/ACTION';
import { mapActions, mapGetters } from 'vuex';
import { Preloader } from '@/preloader';
import PromoIconButton from '@/components/panel/PromoIconButton.vue';
import ProgressBar from '@/components/progress/ProgressBar.vue';
import WelcomePopup from '@/components/welcome_popup/WelcomePopup.vue';
import AchievementsWelcomeContent from '@/components/welcome_popup/AchievementsWelcomeContent.vue';
import TournamentWelcomeContent from '@/components/welcome_popup/TournamentWelcomeContent.vue';
import CommonPopup from '@/components/common_popup/CommonPopup.vue';
import WrapperFreeSpins from '@/components/freeSpinsPopups/WrapperFreeSpins.vue';
import StartFreeSpin from '@/components/freeSpinsPopups/StartFreeSpin.vue';
import FinishFreeSpin from '@/components/freeSpinsPopups/FinishFreeSpin.vue';
import StartFreeSpinOtherGame from '@/components/freeSpinsPopups/StartFreeSpinOtherGame.vue';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import MoreIcons from '@/components/moreIcons/MoreIcons.vue';
import WinPrizeAfterOneSpin from '@/components/freeSpinsPopups/WinPrizeAfterOneSpin.vue';
import promoIconButtonCount from '@/components/panel/PromoIconButtonCount.vue';
import progressBarCheck from '@/components/progress/ProgressBarCheck.vue';
import TabWelcomeWrapper from '@/components/welcome_popup/tabWelcome/TabWelcomeWrapper.vue';
import MessageWrapper from '@/components/messages/MessageWrapper.vue';
import '@/mainComponent/PromoComponent.ts';

window.addEventListener('resize', () => onResize());
window.addEventListener('keydown', e => closePopups(e));

onResize();

function onResize(): void {
  store.dispatch(ACTION.ON_RESIZE);
}

function closePopups(e: KeyboardEvent) {
  if (e.keyCode !== 32) return;

  store.dispatch(ACTION.HIDE_COMMON_POPUP);
  store.dispatch(ACTION.HIDE_FREESPIN_WIN_OTHER_GAME);
  store.dispatch(ACTION.HIDE_FREESPIN_WIN);
  store.dispatch(ACTION.HIDE_WELCOME_POPUP);
  if (store.getters.isFreeSpinFinishPopup) store.dispatch(ACTION.HIDE_FREESPIN_FINISH);
}

export default Vue.extend({
  name: 'App',
  components: {
    PromoIconButton,
    ProgressBar,
    WelcomePopup,
    AchievementsWelcomeContent,
    TournamentWelcomeContent,
    CommonPopup,
    WrapperFreeSpins,
    StartFreeSpin,
    FinishFreeSpin,
    StartFreeSpinOtherGame,
    Tooltip,
    MoreIcons,
    WinPrizeAfterOneSpin,
    promoIconButtonCount,
    progressBarCheck,
    TabWelcomeWrapper,
    MessageWrapper
  },
  methods: {
    ...mapActions(['CHANGE_STATUS_MENU']),
    toggleMenuIcons: function (status: boolean): void {
      this.CHANGE_STATUS_MENU(status);
    }
  },
  mounted() {
    setTimeout(() => {
      document.dispatchEvent(new Event('promoLoaded'));
    }, 200);
  },
  computed: {
    ...mapGetters([
      'getAchievementShowingIcon',
      'getTournamentShowingIcon',
      'getAchievementWelcomePopup',
      'getTournamentShowingWelcomePopup',
      'hasAchievement',
      'isProgressShow',
      'isFreeSpinWInPopup',
      'isFreeSpinFinishPopup',
      'isFreeSpinWInOtherGamePopup',
      'getShowingCommonPopup',
      'isShowMenu',
      'getProgressData',
      'isAchievementFreeSpinGame',
      'isTournamentFreeSpinGame',
      'isFreeRounds',
      'isPrizeGameWinPopup',
      'isShowIconCount',
      'isShowProgressCheck',
      'isShowFreeBetWelcomePopup',
      'hasFreeBet',
      'hasTournament'
    ]),
    getCurrentStep(): number | string | undefined {
      return (Object.values(this.getProgressData)[0] as { current: number; total: number } | undefined)?.current;
    },
    getTotalStep(): number | string | undefined {
      return (Object.values(this.getProgressData)[0] as { current: number; total: number } | undefined)?.total;
    },
    isProgress(): boolean {
      if (!this.hasAchievement || this.isFreeRounds) return false;
      return Number(this.getCurrentStep) < Number(this.getTotalStep);
    },
    isShowProgressBar(): boolean {
      return (
        (this.isFreeRounds || this.isAchievementFreeSpinGame || this.isProgress || this.isTournamentFreeSpinGame) &&
        this.isProgressShow
      );
    }
  }
});
</script>

<style lang="scss">
@import 'assets/styles/reset';
@import 'assets/styles/main';
</style>
